/**
 * `diary_homework.sub_type` 的讀寫。
 *
 * 欄位是 varchar(20)，內容是 JSON 陣列的字面值（例如 `[0,3,5]`），
 * 一個數字代表一個獨立開關：
 *
 *   0  月曆顯示模式
 *   2  英文 AI 評分
 *   3  ⚠ 兩個後端命名不同：studio-api 叫 NO_NEED_PASSWORD（免密碼加入）、
 *      console-api 叫 AI_REPLY。沒有任何一邊真的讀它，先不動。
 *   5  AI 範例
 *   6  有量表（Drawer.vue 用它決定選單要不要出現）
 *   7  報名需 email    8  報名需電話    9  報名需來源
 *   10 預設範例
 *
 * ⚠⚠ 每個編輯畫面只認得其中幾個。存檔時**不要**重建整個陣列——沒有對應
 * 輸入元件的位元一律原樣帶回去。這些旗標大多沒有管理介面，被覆蓋後還原
 * 不回來，而且畫面上看不出發生了什麼事（曾經因此清掉 5 與 10）。
 */

export const SUB_TYPE_CALENDAR = 0;
export const SUB_TYPE_AI_SCORING = 2;
export const SUB_TYPE_AI_SAMPLE = 5;
export const SUB_TYPE_DEFAULT_SAMPLE = 10;

/**
 * 把後端回的 `sub_type` 轉成數字陣列，解析不出來回 `null`。
 *
 * ⚠ 回 `null` 而不是 `[]`：`[]` 會讓存檔誤以為「本來就沒有任何旗標」，
 * 於是把不認得的位元清掉。呼叫端拿到 `null` 就整個不要送這個欄位——
 * 後端對 falsy 會跳過不寫，欄位原樣保留。猜一個值寫回去比不寫更糟。
 *
 * ⚠ 也接受已經是陣列的輸入。後端有一支 API（`getHomeworkName`）會先幫忙
 * `JSON.parse`，兩種形狀都可能進來。
 *
 * @param {string|Array} raw
 * @returns {number[]|null}
 */
export function parseSubType(raw) {
    const list = Array.isArray(raw) ? raw : tryParseJsonArray(raw);
    if (list === null) {
        return null;
    }
    return list.map(Number).filter((v) => Number.isInteger(v));
}

function tryParseJsonArray(raw) {
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
        return null;
    }
}

/**
 * 只改寫 `ownedTypes` 裡的位元，其餘原樣保留。
 *
 * @param {number[]} current 載入時解析出來的陣列
 * @param {number[]} ownedTypes 這個畫面有輸入元件、因此有權改寫的位元。
 *   ⚠ 選項被 `v-if` 藏起來時**不要**列進來——畫面上看不到就沒有地方改回來。
 * @param {number[]} selected 這次要開啟的位元（`ownedTypes` 的子集）
 * @returns {number[]} 遞增排序的新陣列。排序與既有資料的寫法一致，
 *   也讓「沒有改動」不會產生假差異。
 */
export function mergeSubType(current, ownedTypes, selected) {
    const kept = current.filter((v) => ownedTypes.indexOf(v) === -1);
    return selected.concat(kept).sort((a, b) => a - b);
}
